import { fetch } from '@atlassian/eoc-fetch';

import { type SidebarRightsResponse, type Team } from '../../common/types';

export const getTeamByIdEndpoint = (teamId: string) =>
	fetch<Team>(`/v1/teams/${teamId}?includeImageUrls=true`);

export const getSidebarRightsEndpoint = (teamId: string) => {
	return fetch<SidebarRightsResponse>(`/v1/teams/${teamId}/menu-rights`);
};
